import React, { useState } from 'react';
import BaseCard from '../../components/base/BaseCard';
import FuturesHeader from './components/FuturesHeader';
import FuturesMetricsCard from './components/FuturesMetricsCard';
import FuturesSettingsModal from './components/FuturesSettingsModal';
import ExtrapolationMatrix from '../calculator/components/matrix/ExtrapolationMatrix';
import { useFuturesCalculator } from './hooks/useFuturesCalculator.ts';
import { useViewMode } from '../../hooks/useViewMode';

const FuturesCalculator = () => {
  const [viewMode, setViewMode] = useViewMode();
  const {
    values,
    setValues,
    metrics,
    contractSpec,
    isCalculating,
  } = useFuturesCalculator();

  // Settings modal state
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [initialFocusField, setInitialFocusField] = useState(null);

  const handleOpenSettings = (field = null) => {
    setInitialFocusField(field);
    setIsSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setIsSettingsOpen(false);
    setInitialFocusField(null);
  };

  return (
    <div className="flex justify-center pt-0 px-3 sm:px-6 pb-6">
      <div className="w-full max-w-5xl space-y-4">
        {/* Card 1: Header */}
        <BaseCard>
          <FuturesHeader
            values={values}
            setValues={setValues}
            contractSpec={contractSpec}
            onOpenSettings={handleOpenSettings}
            isCalculating={isCalculating}
          />
        </BaseCard>

        {/* Card 2: Metrics */}
        <FuturesMetricsCard
          metrics={metrics}
          contractSpec={contractSpec}
          values={values}
          isLoading={isCalculating}
          onSetValues={setValues}
          viewMode={viewMode}
        />

        {/* Card 3: Extrapolation Matrix */}
        <ExtrapolationMatrix
          positionType={metrics.positionType}
          nominalRR={values.desiredRR}
          effectiveRR={metrics.netRR}
          risk={values.risk}
          accountBalance={values.accountBalance}
          disabled={isCalculating}
        />
      </div>

      {/* Settings Modal */}
      <FuturesSettingsModal
        isOpen={isSettingsOpen}
        onClose={handleCloseSettings}
        values={values}
        setValues={setValues}
        initialFocusField={initialFocusField}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />
    </div>
  );
};

export default FuturesCalculator;
